/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://wdonfmazivf3bkz6y6t4mlrfdm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-s3unubu3tfh3ff5kyupbi4m4pu",
    "aws_cognito_identity_pool_id": "us-east-1:2e54bc1a-5510-44c8-ae99-1f47dcac5d11",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_SASatatAB",
    "aws_user_pools_web_client_id": "5ihcrp9fj5nhgrl5vgl10rh9qj",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "brandzooka-account-storage-bucket-prodb",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
